var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.voices.length)?_c('v-select',{key:"Id",attrs:{"outlined":"","items":_vm.voices,"item-text":_vm.getItemText,"label":_vm.$t('voice2'),"return-object":""},on:{"change":_vm.onChange},model:{value:(_vm.voiceProps),callback:function ($$v) {_vm.voiceProps=$$v},expression:"voiceProps"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }